import TransactionProduct from './TransactionProduct';

export default TransactionProduct;
